import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "fixed inset-0 z-10 overflow-y-auto" }
const _hoisted_2 = { class: "flex items-start justify-center min-h-full px-8 mt-8" }
const _hoisted_3 = { class: "max-w-5xl mx-auto mt-8 overflow-hidden transition-all transform" }
const _hoisted_4 = { class: "relative underline" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "p-4 mt-4 bg-white border divide-y divide-gray-200 rounded-lg border-clay-300"
}
const _hoisted_7 = { class: "" }
const _hoisted_8 = { class: "flex flex-wrap items-center justify-between sm:flex-nowrap" }
const _hoisted_9 = { class: "shrink-0" }
const _hoisted_10 = ["href"]
const _hoisted_11 = {
  key: 0,
  class: "grid-cols-1 py-2 text-sm text-gray-800 sm:grid sm:grid-cols-3",
  id: "options",
  role: "listbox"
}
const _hoisted_12 = {
  key: 1,
  class: "grid-cols-1 py-2 text-sm text-gray-800 sm:grid sm:grid-cols-3",
  id: "options",
  role: "listbox"
}
const _hoisted_13 = { class: "py-2 text-sm text-gray-800" }
const _hoisted_14 = { class: "flex flex-wrap items-center -m-1" }
const _hoisted_15 = ["href"]
const _hoisted_16 = {
  key: 2,
  class: "py-2 text-sm text-gray-800"
}
const _hoisted_17 = { class: "flex flex-wrap items-center -m-1" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["href"]
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "px-4 py-2" }
const _hoisted_22 = { class: "flex flex-wrap items-center justify-between sm:flex-nowrap" }
const _hoisted_23 = { class: "text-sm leading-6 text-clay-800" }
const _hoisted_24 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_25 = ["onClick"]

import {computed, ref} from "vue";
import {Dialog, DialogPanel, TransitionChild, TransitionRoot} from '@headlessui/vue';
import {client} from '@/shared';
import {
    CategoryWithCount, 
    LearningModuleDtoLightWeight,
    SearchGuidesUsingAutocomplete,
    SearchGuidesUsingAutocompleteResponse, 
    ShowDto,
} from "@/dtos";
import ShowCardMinimal from "../Guides/Shows/ShowCardMinimal.vue";
import LearningModuleCardMinimal from "../LearningModules/LearningModuleCardMinimal.vue";
// @ts-ignore
import { useDebounceFn } from '@vueuse/core';
import SkeletonCard from "@/main/components/skeletons/SkeletonCard.vue";
import {store} from "@/store";
import {trackEvent} from '@/shared';


export default /*@__PURE__*/_defineComponent({
  __name: 'GeneralSearchAutocomplete',
  setup(__props) {

// @ts-ignore
const queryTextRef = ref(null);

const closeConfirmation = async () => {
    store.openSearchDialog = false;
}

const shows = ref<Array<ShowDto>>([]);
const learningModules = ref<Array<LearningModuleDtoLightWeight>>([]);
const otherResults = ref<Array<CategoryWithCount>>([]);
const relatedTags = ref<string>([]);
const queryText = ref('');
const hasResults = ref(false);
const isRetrieving = ref(false);

const onQueryTextChanged = useDebounceFn(async () => {

    if (queryText.value.length >= 3) {
        isRetrieving.value = true;
        await client.get<SearchGuidesUsingAutocompleteResponse>(new SearchGuidesUsingAutocomplete({q: queryText.value}))
            .then(res => {
                shows.value = res.shows;
                learningModules.value = res.learningModules;
                otherResults.value = res.categoriesWithCounts;
                relatedTags.value = res.relatedTags;
                hasResults.value = otherResults.value.some((r: any) => r.totalResults > 0);
                suggestionsWhenNoResults.value = res.suggestions;
                isRetrieving.value = false;
            });
        
        trackEvent( 'search', {
            search_term: queryText.value
        }, false);
    }
}, 1000)

const onRelatedTagClicked = async (clickedTag: string) => {
    queryText.value = clickedTag;
    await onQueryTextChanged();
}

const suggestionsWhenNoResults = ref<string>([]);
const hasSuggestions = computed(() => {
    return isRetrieving.value === false && queryText?.value.length >= 3 && suggestionsWhenNoResults.value.length > 0;
});

const onSuggestionClicked = async (suggestion: string) => {
    queryText.value = suggestion;
    await onQueryTextChanged();
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    show: _unref(store).openSearchDialog,
    as: "template"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        initialFocus: queryTextRef.value,
        class: "relative z-50",
        onClose: closeConfirmation
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(TransitionChild), {
            as: "template",
            enter: "ease-out duration-300",
            "enter-from": "opacity-0",
            "enter-to": "opacity-100",
            leave: "ease-in duration-200",
            "leave-from": "opacity-100",
            "leave-to": "opacity-0"
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createElementVNode("div", { class: "fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" }, null, -1)
            ])),
            _: 1
          }),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(DialogPanel), { class: "relative w-full max-w-5xl px-4 py-8 overflow-hidden text-left transition-all transform border border-2 rounded-lg shadow-sm shadow-xl bg-clay-50 lg:w-2/3 sm:mt-24 lg:px-8 border-clay-500" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", { class: "absolute top-0 right-0 block pt-4 pr-4" }, [
                    _createElementVNode("button", {
                      class: "text-gray-400 bg-white rounded-md hover:text-clay-800 focus:outline-hidden",
                      type: "button",
                      onClick: closeConfirmation
                    }, _cache[3] || (_cache[3] = [
                      _createElementVNode("span", { class: "sr-only" }, "Close", -1),
                      _createElementVNode("svg", {
                        class: "w-6 h-6",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "1.5",
                        viewBox: "0 0 24 24",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          d: "M6 18L18 6M6 6l12 12",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        })
                      ], -1)
                    ]))
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _cache[4] || (_cache[4] = _createElementVNode("svg", {
                          "aria-hidden": "true",
                          class: "pointer-events-none absolute top-3.5 left-4 h-5 w-5 text-gray-400",
                          viewbox: "0 0 20 20"
                        }, [
                          _createElementVNode("path", {
                            "clip-rule": "evenodd",
                            d: "M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.452 4.391l3.328 3.329a.75.75 0 11-1.06 1.06l-3.329-3.328A7 7 0 012 9z",
                            "fill-rule": "evenodd"
                          })
                        ], -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryText).value = $event)),
                          onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(onQueryTextChanged) && _unref(onQueryTextChanged)(...args))),
                          ref_key: "queryTextRef",
                          ref: queryTextRef,
                          "aria-controls": "options",
                          "aria-expanded": "false",
                          class: "w-full h-12 pr-4 text-gray-800 placeholder-gray-400 bg-transparent bg-white border rounded-md focus:font-semibold pl-11 sm:text-2xl focus:border-2 focus:border-clay-500 border-clay-300",
                          placeholder: "Search StageAgent",
                          role: "combobox",
                          type: "text"
                        }, null, 544), [
                          [_vModelText, queryText.value]
                        ])
                      ]),
                      _cache[11] || (_cache[11] = _createElementVNode("p", { class: "block px-10 pt-2 italic text-gray-600" }, "Input a name, title or keyword", -1)),
                      (isRetrieving.value)
                        ? (_openBlock(), _createBlock(SkeletonCard, {
                            key: 0,
                            class: "mt-3",
                            "card-style": "long",
                            "num-of-cards": 1
                          }))
                        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            (hasResults.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                  _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("div", _hoisted_8, [
                                      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "" }, [
                                        _createElementVNode("h3", { class: "text-base font-semibold leading-6 text-gray-900" }, "Suggested")
                                      ], -1)),
                                      _createElementVNode("div", _hoisted_9, [
                                        _createElementVNode("a", {
                                          href: `/search?term=${queryText.value}`,
                                          class: "relative inline-flex items-center px-3 py-2 text-sm font-semibold text-gray-800 underline rounded-md hover:text-gray-900"
                                        }, "See all results", 8, _hoisted_10)
                                      ])
                                    ])
                                  ]),
                                  (shows.value.length > 0)
                                    ? (_openBlock(), _createElementBlock("ul", _hoisted_11, [
                                        _cache[6] || (_cache[6] = _createElementVNode("li", {
                                          class: "col-span-3 px-4 pt-2 text-lg cursor-default select-none",
                                          id: "option-1",
                                          role: "option",
                                          tabindex: "-1"
                                        }, " Shows ", -1)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shows.value, (show) => {
                                          return (_openBlock(), _createElementBlock("li", {
                                            key: show.id,
                                            class: "px-4 py-2"
                                          }, [
                                            _createVNode(ShowCardMinimal, { show: show }, null, 8, ["show"])
                                          ]))
                                        }), 128))
                                      ]))
                                    : _createCommentVNode("", true),
                                  (learningModules.value.length > 0)
                                    ? (_openBlock(), _createElementBlock("ul", _hoisted_12, [
                                        _cache[7] || (_cache[7] = _createElementVNode("li", {
                                          class: "col-span-3 px-4 pt-2 text-lg cursor-default select-none",
                                          id: "option-1",
                                          role: "option",
                                          tabindex: "-1"
                                        }, " Learning Modules ", -1)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(learningModules.value, (guide) => {
                                          return (_openBlock(), _createElementBlock("li", {
                                            key: guide.id,
                                            class: "px-4 py-2"
                                          }, [
                                            _createVNode(LearningModuleCardMinimal, { guide: guide }, null, 8, ["guide"])
                                          ]))
                                        }), 128))
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_13, [
                                    _cache[8] || (_cache[8] = _createElementVNode("p", { class: "block w-full px-4 pt-2 mb-2 text-lg cursor-default select-none flex-0" }, " Other Results", -1)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(otherResults.value.filter(x=>x.totalResults > 0), (result) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: result.category,
                                        class: "inline-block mt-2 space-x-3 space-y-2 sm:ml-4 sm:mt-0"
                                      }, [
                                        _createElementVNode("div", _hoisted_14, [
                                          _createElementVNode("a", {
                                            href: `/search?term=${encodeURIComponent(queryText.value)}&category=${encodeURIComponent(result.category)}`,
                                            class: "inline-flex px-2 py-1 m-1 mb-2 text-sm font-semibold capitalize rounded-full bg-powder-200 text-powder-700 hover:bg-powder-100 hover:text-powder-700 hover:shadow-sm"
                                          }, [
                                            _createElementVNode("span", null, _toDisplayString(result.category) + " (" + _toDisplayString(result.totalResults) + ")", 1)
                                          ], 8, _hoisted_15)
                                        ])
                                      ]))
                                    }), 128))
                                  ]),
                                  (relatedTags.value.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                        _cache[9] || (_cache[9] = _createElementVNode("p", { class: "block w-full px-4 pt-2 mb-2 text-lg cursor-default select-none flex-0" }, " Related Searches", -1)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(relatedTags.value, (tag) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: tag,
                                            class: "inline-block mt-2 space-x-3 space-y-2 sm:ml-4 sm:mt-0"
                                          }, [
                                            _createElementVNode("div", _hoisted_17, [
                                              _createElementVNode("a", {
                                                onClick: ($event: any) => (onRelatedTagClicked(tag)),
                                                href: "#",
                                                class: "inline-flex px-2 py-1 m-1 mb-2 text-xs font-medium border rounded-full text-clay-800 bg-clay-50 hover:border-clay-900 hover:border hover:text-clay-700 hover:bg-clay-100"
                                              }, [
                                                _createElementVNode("span", null, _toDisplayString(tag), 1)
                                              ], 8, _hoisted_18)
                                            ])
                                          ]))
                                        }), 128))
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("a", {
                                    href: `/search?term=${queryText.value}`,
                                    class: "rounded-full bg-clay-950 px-2.5 py-1.5 font-semibold text-clay-100 hover:bg-clay-900 hover:text-clay-50 hover:shadow-sm mt-4 min-w-full block text-center"
                                  }, " See all results ", 8, _hoisted_19)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                  _createElementVNode("div", _hoisted_21, [
                                    _createElementVNode("div", _hoisted_22, [
                                      _createElementVNode("h3", _hoisted_23, [
                                        _createTextVNode(_toDisplayString(isRetrieving.value === false && queryText.value?.length >= 3 ? 'No results found': '') + " ", 1),
                                        (hasSuggestions.value)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                              _cache[10] || (_cache[10] = _createElementVNode("span", { class: "mr-3 text-clay-900" }, "Did you mean:", -1)),
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(suggestionsWhenNoResults.value, (suggestion) => {
                                                return (_openBlock(), _createElementBlock("span", {
                                                  class: "mr-2 text-clay-800 underline cursor-pointer hover:no-underline",
                                                  onClick: _withModifiers(($event: any) => (onSuggestionClicked(suggestion)), ["prevent"])
                                                }, _toDisplayString(suggestion), 9, _hoisted_25))
                                              }), 256))
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ])
                                ]))
                          ]))
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["initialFocus"])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})